import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

import { Info } from './EffectsPairedInfo.style';
import { variables } from '../../../styles/variables';

interface Props {
  /** informacja czy efekty są sparowane */
  areEffectsPaired: boolean;
}

/**
 * Komponent wyświetlający informację czy efekty w karcie przedmiotów zostały sparowane.
 *
 */
function EffectsPairedInfo(props: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Info areEffectsPaired={props.areEffectsPaired}>
      <p>
        <strong>{t('SUBJECT_CARD_ARE_EFFECTS_PAIRED')}:</strong>
      </p>
      {props.areEffectsPaired ? (
        <CheckCircleTwoTone twoToneColor={variables.colorSuccess} />
      ) : (
        <CloseCircleTwoTone twoToneColor={variables.colorError} />
      )}
      <span>{t(`${props.areEffectsPaired ? 'YES' : 'NO'}`)}</span>
    </Info>
  );
}

export default React.memo(EffectsPairedInfo);
